import { TokenData } from '@app/api/auth.api';
import { UserModel } from '@app/interfaces/user';

export const persistToken = (tokenData: TokenData): void => {
  localStorage.setItem('tokenData', JSON.stringify(tokenData));
};

export const readToken = (): TokenData | null => {
  const tokenStr = localStorage.getItem('tokenData');
  return tokenStr ? JSON.parse(tokenStr) : null;
};

export const persistUser = (user: UserModel): void => {
  localStorage.setItem('user', JSON.stringify(user));
};

export const readUser = (): UserModel | null => {
  const userStr = localStorage.getItem('user');

  return userStr ? JSON.parse(userStr) : null;
};

export const deleteToken = (): void => localStorage.removeItem('tokenData');
export const deleteUser = (): void => localStorage.removeItem('user');
